import { IonContent, IonFooter, IonToolbar } from '@ionic/react';
import PageHeader from '../../components/headers/PageHeader';
import { useTranslation } from 'react-i18next';
import CheckoutButton from '../../../../components-library/buttons/CheckoutButton';
import { ReactElement } from 'react';
import OrderConfirmationScreen from '../../../../pages/checkout/OrderConfirmationScreen';
import ProceedToPaymentButton from '../../../../components-library/checkout/ProceedToPaymentButton';
import useDraftError from '../../../../hooks/order/useDraftError';

const Content = (): ReactElement => {
  // Same shape as OrderPaymentPage: the CTA footer is a sibling of the screen and would
  // survive the screen's early return to OrderDraftErrorPage. Same hook and options as
  // OrderConfirmationScreen, so the footer cannot vanish on a screen that still renders.
  const { show: showDraftError } = useDraftError({ recoversDeliveryDetails: true, recoversCustomerInput: true });

  if (showDraftError) {
    return <OrderConfirmationScreen className="pb-[230px]" />;
  }

  return (
    <>
      <OrderConfirmationScreen className="pb-[230px]" />
      <IonFooter className="">
        <IonToolbar className="ion-color !p-0 [&::part(container)]:p-0 bg-white fixed bottom-0 w-full safe-area-bottom">
          <CheckoutButton>
            <ProceedToPaymentButton className="!rounded-lg !font-semibold" />
          </CheckoutButton>
        </IonToolbar>
      </IonFooter>
    </>
  );
};

const OrderConfirmationPage = (): ReactElement => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:CheckoutPage' });

  return (
    <>
      <PageHeader title={t('title')} />
      <IonContent className="safe-area-bottom">
        <Content />
      </IonContent>
    </>
  );
};

export default OrderConfirmationPage;
